export enum BorderRadius {
  s = '4px',
  m = '6px',
  l = '12px',
  xl = '16px'
};
